<div class="card-content">
    <div class="tem-card">
        <div class="tem-card__header">
            <span class="tem-card__title">{{'correios.preco.title'|translateTA}}</span>
            <button nz-button nzType="primary" nzShape="circle" type="button"
                    nz-tooltip [nzTooltipTitle]="'correios.preco.consult'|translateTA" (click)="consultar()">
                <nz-icon nzType="search" />
            </button>
            <nz-divider nzType="vertical"></nz-divider>
            <button nz-button nzType="text" nzShape="circle" type="button"
                    nz-tooltip [nzTooltipTitle]="'correios.preco.config'|translateTA" (click)="openConfig()">
                <nz-icon nzType="setting" />
            </button>
        </div>
        <div class="tem-card__body" [formGroup]="formValidation">
            <div class="cep-fields-grid">
                <div class="columns-data">
                    <div class="tem-field">
                        <span class="tem-field-label">{{'correios.cepOrigin'|translateTA}}</span>
                        <input nz-input formControlName="origem" [placeholder]="'correios.cepOrigin'|translateTA"
                               type="text" mask="00000-000" (keyup.enter)="consultar()" />
                    </div>
                </div>
                <div class="columns-data">
                    <div class="tem-field">
                        <span class="tem-field-label">{{'correios.cepDest'|translateTA}}</span>
                        <input nz-input formControlName="destino" [placeholder]="'correios.cepDest'|translateTA"
                               type="text" mask="00000-000" (keyup.enter)="consultar()" />
                    </div>
                </div>
                <div class="columns-data">
                    <div class="tem-field">
                        <span class="tem-field-label">{{'correios.preco.declaredValue'|translateTA}}</span>
                        <input nz-input formControlName="vlrdeclarado" [placeholder]="'correios.preco.declaredValue'|translateTA"
                               type="number" min="0" (keyup.enter)="consultar()" />
                    </div>
                </div>
            </div>

            <div class="cep-fields-grid">
                <div class="columns-data-detail">
                    <div class="tem-field" nz-tooltip [nzTooltipTitle]="'correios.preco.weightTip'|translateTA">
                        <span class="tem-field-label">{{'correios.preco.weight'|translateTA}}</span>
                        <input nz-input formControlName="peso" [placeholder]="'correios.preco.weight'|translateTA" type="number" min="0" />
                    </div>
                </div>
                <div class="columns-data-detail">
                    <div class="tem-field">
                        <span class="tem-field-label">{{'correios.preco.height'|translateTA}}</span>
                        <input nz-input formControlName="altura" [placeholder]="'correios.preco.height'|translateTA" type="number" min="0" />
                    </div>
                </div>
                <div class="columns-data-detail">
                    <div class="tem-field">
                        <span class="tem-field-label">{{'correios.preco.width'|translateTA}}</span>
                        <input nz-input formControlName="largura" [placeholder]="'correios.preco.width'|translateTA" type="number" min="0" />
                    </div>
                </div>
                <div class="columns-data-detail">
                    <div class="tem-field">
                        <span class="tem-field-label">{{'correios.preco.diameter'|translateTA}}</span>
                        <input nz-input formControlName="diametro" [placeholder]="'correios.preco.diameter'|translateTA" type="number" min="0" />
                    </div>
                </div>
                <div class="columns-data-detail">
                    <div class="tem-field">
                        <span class="tem-field-label">{{'correios.preco.length'|translateTA}}</span>
                        <input nz-input formControlName="comprimento" [placeholder]="'correios.preco.length'|translateTA" type="number" min="0" />
                    </div>
                </div>
            </div>

            <div class="resultado">
                <ul *ngIf="mensagemObj.length > 0">
                    <li *ngFor="let item of mensagemObj">
                        <span class="key-class">{{item.key}}</span> -<span class="value-class"> {{item.value}}</span>
                    </li>
                </ul>
                <nz-empty *ngIf="mensagemObj.length === 0" nzNotFoundImage="simple"
                          [nzNotFoundContent]="'correios.preco.empty'|translateTA"></nz-empty>
            </div>
        </div>
    </div>
</div>
